import { supabase } from '../supabase';
import { weekClockFor } from '../utils/programWeeks';

// The coach moves a client to a week (Set Week, or "Generate & move"). The week clock moves with it
// (migration 092), so the client's screen counts weeks from this moment and does not move them on again
// or record misses for days they never had (programme 193, 25 October 2026).
//
// Until 092 has run the column does not exist (PGRST204): the week alone is saved, as before.
// A refused update matches no row and says nothing, so a row must come back.
export const setClientWeek = async (userId, week, now = new Date()) => {
  const fields = { current_week: week, current_week_index: null, current_day_index: null };
  const update = (values) => supabase
    .from('program_assignments')
    .update(values)
    .eq('user_id', userId)
    .eq('is_active', true)
    .select('id');
  let result = await update({ ...fields, week_clock_from: weekClockFor(week, now) });
  if (result.error?.code === 'PGRST204') result = await update(fields);
  if (result.error) throw result.error;
  if (!result.data?.length) throw new Error("The client's week was not changed: no active programme you may edit.");
};
